// Urgent pop-ups (price & whale alerts) in the top-right corner. Each one
// closes itself after a while; hovering pauses the timer (CSS animation).
import { useT } from '@/i18n';
import { useTime } from '@/hooks/useTime';
import { cx } from '@/lib/format';
import { KIND_LABEL, NoticeIcon } from './NoticeIcon';
import { useNotices } from './NoticesProvider';

export function UrgentStack() {
  const { popups, open, dismiss } = useNotices();
  const tf = useTime();
  const { t } = useT();
  return (
    <div className="npop-stack" aria-live="assertive" aria-relevant="additions">
      {popups.map((n) => (
        <div key={n.id} className={cx('npop', n.kind, n.dir)} role="alert">
          <NoticeIcon n={n} />
          <button type="button" className="npop-b" onClick={() => open(n)}>
            <span className="npop-k"><em>{t('notices:urgentOne')}</em>{KIND_LABEL[n.kind]} · {tf.time(n.at)}</span>
            <b>{n.title}</b>
            <small>{n.body}</small>
          </button>
          <button type="button" className="npop-x" aria-label={t('a11y.close')} onClick={() => dismiss(n.id)}><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg></button>
          <i className="npop-bar" onAnimationEnd={() => dismiss(n.id)} />
        </div>
      ))}
    </div>
  );
}
